import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import GarageForm from "./GarageForm";
import strings from "../../core/translate";

// One dialog that covers everything a garage needs: details, map location and photos.
const GarageFormModal = ({
  isOpen,
  garage,
  merchantId,
  history,
  onClose,
  onSaved,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onClose}
    size="lg"
    className="garage-modal"
  >
    <ModalHeader toggle={onClose}>
      {garage && garage.id
        ? `${strings.edit} ${strings.garage}`
        : strings.add_garage}
    </ModalHeader>
    <ModalBody>
      {isOpen && (
        <GarageForm
          // remount on a different garage so the fields always start fresh
          key={(garage && garage.id) || "new"}
          garage={garage}
          merchantId={merchantId}
          history={history}
          onSaved={onSaved}
          onCancel={onClose}
        />
      )}
    </ModalBody>
  </Modal>
);

export default GarageFormModal;
